export default "__VITE_ASSET__d0f165a4__"